import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/core/services/api/api.service';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { RoleService } from 'src/app/core/services/role/role.service';
import { LogoutDialogComponent } from './components/logout-dialog/logout-dialog.component';

interface searchType {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit {
  @Input() sidenavReference: MatSidenav;
  @Output() pathChange = new EventEmitter<string>();

  currentPath: string;
  componentToDisplay: string;

  userRole: string;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private data: DataService,
    private media: MediaObserver,
    private apiService: ApiService,
    private localStorage: LocalStorageService,
    public roleService: RoleService,
    private dialog: MatDialog,
    private role: RoleService
  ) {}

  ngOnInit(): void {
    this.data.currentPath.subscribe((path) => {
      this.currentPath = path;
      this.pathChange.emit(path);
    });
  }

  logout() {
    if (this.role.getCurrentOfflineStatus() === true) {
      const dialogRef = this.dialog.open(LogoutDialogComponent);

      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result) {
          this.authService
            .logout()
            .then(() => {
              this.router.navigate(['auth/login']);
              this.sidenavReference.close();
              // refresh after 1 second
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((e) => console.log(e.message));
        }
      });
    } else {
      this.authService
        .logout()
        .then(() => {
          this.router.navigate(['auth/login']);
          this.sidenavReference.close();
          // refresh after 1 second
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((e) => console.log(e.message));
    }
  }

  changeRoute(route: string) {
    this.router.navigate([route]);

    if (this.media.isActive('xs')) {
      this.sidenavReference.close();
    }
  }
}
